const DEFAULT_SCALE = 4;
const TABLE_ROW_HEIGHT = 54;
const spacer = {
  spacer1: 4,
  spacer2: 8,
  spacer3: 16,
  spacer4: 24,
  spacer5: 32,
  spacer6: 40,
  spacer7: 80
};
const sizes = {
  xSmall: 246,
  small: 300,
  xsmedium: 410,
  medium: 640,
  large: 1080,
  extraLarge: 1550,
  borderRadius: '5px',
  drawerWidth: 260,
  appBarHeight: 75,
  footerBarHeight: 48,
  mobileSubHeaderHeight: 50
};
const borderDefinition = function () {
  let color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'rgba(0, 0, 0, 0.12)';
  let borderSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1px';
  return "".concat(borderSize, " solid ").concat(color);
};
const boxShadowDefinition = function () {
  let size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '0px 0px 0px 0px';
  let color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'rgba(0, 0, 0, 0.2)';
  return "".concat(size, " ").concat(color);
};
const boxShadow = '10px 2px 5px rgba(0, 0, 0, 0.12)';
const dropShadow = '0 2px 3px rgba(0, 0, 0, 0.3)';
const softShadow = '0 5px 10px rgba(0,0,0,.05)';
const boxShadowLight = '0 0 4px 2px rgba(0, 0, 0, 0.03)';
const extraLargeBorderRadius = '50px';
const largeBorderRadius = '25px';
const mediumBorderRadius = '15px';
const smallBorderRadius = '5px';
export { DEFAULT_SCALE, TABLE_ROW_HEIGHT, spacer, sizes, borderDefinition, boxShadowDefinition, boxShadow, boxShadowLight, dropShadow, softShadow, extraLargeBorderRadius, largeBorderRadius, smallBorderRadius, mediumBorderRadius };